import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { BillingTemplateModal } from './BillingTemplateModal';
import { AmenityModal } from './AmenityModal';
import { ReimbursementModal } from './ReimbursementModal';
import { FeeSetupModal } from './FeeSetupModal';
import { useStore } from 'src/stores';
import { UnitModal } from './UnitModal';
import { PropertyDetailsModal } from './PropertyDetailsModal';
import { EnrollmentModal } from 'src/components/resident/EnrollmentModal';
import { NewBillingModuleContent } from './content';
import { ManageAccessModal } from 'src/components/shared/ManageAccessModal';
import { CreateEditPortfolioModal } from 'src/components/shared/CreateEditPortfolioModal';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import { useTranslation } from 'react-i18next';
import { PayGateModal } from 'src/components/utilities/PayGateModal';
import { toast } from '@livable/saas-react-components';
import CreateAccountModal from 'src/pages/AdminPage/CreateAccountModal';
import { toJS } from 'mobx';
import { OldUtilityConfigurationModal } from './OldUtilityConfigurationModal';
import { ContactInformationModal } from './ContactInformationModal';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
export const NewBillingModule = observer(() => {
  var _store$homeDashboardS6, _store$homeDashboardS7, _store$homeDashboardS8, _store$homeDashboardS9, _store$homeDashboardS0, _enrollModalExtProps$, _store$homeDashboardS1, _store$homeDashboardS10, _enrollModalExtProps$2, _store$homeDashboardS11, _deleteModalProps$sel2;
  const store = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useParams = useParams(),
    navCompanyId = _useParams.navCompanyId,
    navPortfolioId = _useParams.navPortfolioId,
    navPropertyId = _useParams.navPropertyId;
  const _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    setSearchParams = _useSearchParams2[1];
  const queryParams = new URLSearchParams(location.search);
  const fetchPortfoliosDataGeneralUpdateTrigger = async customUnicIds => {
    if (store.admin.companyId) {
      var _store$homeDashboardS;
      await store.portfolios.getPortfoliosDashboardAsync.run({
        storeCompany: true
      }, !customUnicIds && !(customUnicIds !== null && customUnicIds !== void 0 && customUnicIds.length) && store.homeDashboardStore.companyAccessId !== null ? [(_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.companyAccessId] : !!(customUnicIds !== null && customUnicIds !== void 0 && customUnicIds.length) ? customUnicIds : null);
    }
  };
  const fetchPropertyInformation = async () => {
    store.homeDashboardStore.getCurrentCompany.fetchPropertyInformation({
      propertyId: store.homeDashboardStore.selectedPropertyId,
      portfolioId: store.homeDashboardStore.selectedPortfolioId
    });
    store.homeDashboardStore.getCurrentCompany.fetchBuildingInformation({
      propertyId: store.homeDashboardStore.selectedPropertyId,
      portfolioId: store.homeDashboardStore.selectedPortfolioId
    });
    fetchPortfoliosDataGeneralUpdateTrigger([store.homeDashboardStore.selectedPropertyId, store.homeDashboardStore.selectedPortfolioId]);
  };
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCreateAccountModal = _useState2[0],
    setIsCreateAccountModal = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBillingTemplateModalOpen = _useState4[0],
    setBillingTemplateModalOpen = _useState4[1];
  const handleOpenBillingTemplateModal = () => setBillingTemplateModalOpen(true);
  const handleCloseBillingTemplateModal = () => setBillingTemplateModalOpen(false);
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAmenityModalOpen = _useState6[0],
    setAmenityModalOpen = _useState6[1];
  const handleOpenAmenityModal = function () {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        amenityModalPropsInput: null
      },
      amenityModalPropsInput = _ref.amenityModalPropsInput;
    if (amenityModalPropsInput) {
      var _store$homeDashboardS2;
      (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS2 === void 0 || _store$homeDashboardS2.details.setAmenityModalForm(amenityModalPropsInput);
    }
    setAmenityModalOpen(true);
  };
  const handleCloseAmenityModal = () => {
    var _store$homeDashboardS3;
    (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany.selectedPropertyDetails()) === null || _store$homeDashboardS3 === void 0 || _store$homeDashboardS3.details.setAmenityModalForm({});
    setAmenityModalOpen(false);
  };
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isUnitModalOpen = _useState8[0],
    setUnitModalOpen = _useState8[1];
  const handleOpenUnitModal = () => setUnitModalOpen(true);
  const handleCloseUnitModal = function () {
    let triggerRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setUnitModalOpen(false);
    if (triggerRefresh) fetchPortfoliosDataGeneralUpdateTrigger([]);
  };
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isPropertyInfoModalOpen = _useState0[0],
    setPropertyInfoModalOpen = _useState0[1];
  const handleOpenPropertyInfoModal = () => setPropertyInfoModalOpen(true);
  const handleClosePropertyInfoModal = () => setPropertyInfoModalOpen(false);
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isFeeSetupModalOpen = _useState10[0],
    setFeeSetupModalOpen = _useState10[1];
  const handleOpenFeeSetupModal = () => setFeeSetupModalOpen(true);
  const handleCloseFeeSetupModal = () => setFeeSetupModalOpen(false);
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isPaymentMethodModalOpen = _useState12[0],
    setPaymentMethodModalOpen = _useState12[1];
  const handleOpenPaymentMethodModal = () => setPaymentMethodModalOpen(true);
  const handleClosePaymentMethodModal = () => setPaymentMethodModalOpen(false);
  const newPaymentMethodAdded = async () => {
    var _toJS;
    await store.payment.getPaymentMethodsV2Async.run({
      applyToHomeDashboard: true
    });
    await store.payment.getPropertyPaymentMethodAsync.run({
      applyToHomeDashboard: true,
      propertyId: (_toJS = toJS(store.homeDashboardStore.getCurrentProperty)) === null || _toJS === void 0 ? void 0 : _toJS.id
    });
    // toast('success', { body: ['New payment method successfully added'] });
  };
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isReimbursementModalOpen = _useState14[0],
    setReimbursementModalOpen = _useState14[1];
  const handleOpenReimbursementModal = () => setReimbursementModalOpen(true);
  const handleCloseReimbursementModal = () => setReimbursementModalOpen(false);
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEnrollModal = _useState16[0],
    setShowEnrollModal = _useState16[1];
  const _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    enrollModalExtProps = _useState18[0],
    setEnrollModalExtProps = _useState18[1]; // NOTE: EXP OBJ - { portfolioId: '', propertyId: '', enablePortfolioSelect: false, enablePropertySelect: false }
  let handleShowEnrollModal = function (val) {
    let externalEnrolModalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (val) {
      setEnrollModalExtProps(externalEnrolModalProps);
    } else {
      // setEnrollModalExtProps(undefined);
    }
    setShowEnrollModal(val);
  };
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showManageAccessModal = _useState20[0],
    setShowManageAccessModal = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    propsPropertyDataManageAccessModal = _useState22[0],
    setPropsPropertyDataManageAccessModal = _useState22[1];
  const _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    propsPortfolioDataManageAccessModal = _useState24[0],
    setPropsPortfolioDataManageAccessModal = _useState24[1];
  const handleShowManageAccessModal = function (val) {
    let propertyData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let portfolioData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setShowManageAccessModal(val);
    setPropsPropertyDataManageAccessModal(propertyData);
    setPropsPortfolioDataManageAccessModal(portfolioData);
  };
  const _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isDeletePortfolioModalOpen = _useState26[0],
    setIsDeletePortfolioModalOpen = _useState26[1];
  const _useState27 = useState({}),
    _useState28 = _slicedToArray(_useState27, 2),
    deleteModalProps = _useState28[0],
    setDeleteModalProps = _useState28[1];
  const deletePortfolioHandler = async () => {
    await store.portfolios.deletePortfolioAsync.run({
      portfolioId: deleteModalProps === null || deleteModalProps === void 0 ? void 0 : deleteModalProps.portfolioId
    }, [deleteModalProps === null || deleteModalProps === void 0 ? void 0 : deleteModalProps.portfolioId]).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        var _deleteModalProps$sel, _store$homeDashboardS4;
        toast('success', {
          body: [t('portfolios_properties_page.portfolio_deleted', {
            portfolioName: deleteModalProps === null || deleteModalProps === void 0 || (_deleteModalProps$sel = deleteModalProps.selectedPortfolio) === null || _deleteModalProps$sel === void 0 ? void 0 : _deleteModalProps$sel.name
          })]
        });
        setIsDeletePortfolioModalOpen(false);
        if (((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.id) === (deleteModalProps === null || deleteModalProps === void 0 ? void 0 : deleteModalProps.portfolioId)) {
          store.homeDashboardStore.selectActivePortfolioId('all');
        }
        fetchPortfoliosDataGeneralUpdateTrigger([deleteModalProps === null || deleteModalProps === void 0 ? void 0 : deleteModalProps.portfolioId]);
      }
    }).catch(error => {
      toast('error', {
        body: [error]
      });
    });
  };
  const _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isRenamePortfolioModalOpen = _useState30[0],
    setIsRenamePortfolioModalOpen = _useState30[1];
  const _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    renameModalProps = _useState32[0],
    setRenameModalProps = _useState32[1];
  const handleShowCreateEditPortfolioTrigger = (value, renameModalPropsExt) => {
    setIsRenamePortfolioModalOpen(value);
    if (value && renameModalPropsExt) {
      setRenameModalProps(renameModalPropsExt);
    }
    if (value && !renameModalPropsExt) {
      setRenameModalProps(null);
    }
  };
  const _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isContactInformationModalOpen = _useState34[0],
    setIsContactInformationModalOpen = _useState34[1];
  useEffect(() => {
    store.account.getProfileAsync.run(false);
    fetchPortfoliosDataGeneralUpdateTrigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isEnrollModalOpenQueryParams = queryParams.get('enrollModal') === 'true';
  const propertyIdQueryParams = queryParams.get('propertyId');
  if (isEnrollModalOpenQueryParams && propertyIdQueryParams) {
    queryParams.delete('enrollModal');
    queryParams.delete('propertyId');
    setSearchParams(queryParams);
    setTimeout(() => {
      var _store$homeDashboardS5;
      handleShowEnrollModal(true, {
        propertyId: propertyIdQueryParams.toString(),
        portfolioId: (_store$homeDashboardS5 = store.homeDashboardStore.getPortfolioByPropertyId(propertyIdQueryParams)) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.id,
        enablePortfolioSelect: false,
        enablePropertySelect: false
      });
    }, 500);
  }

  // NOTE: Keyboard shortcuts START --------
  let handleShortcutsHintTimerId;
  const handleKeyUp = event => {
    clearTimeout(handleShortcutsHintTimerId);
    store.homeDashboardStore.toggleShortcutsHint(false);
    if (event !== null && event !== void 0 && event.altKey) {
      store.homeDashboardStore.toggleShortcutsHint(false);
    }
  };
  const handleWindowBlur = () => {
    clearTimeout(handleShortcutsHintTimerId);
    store.homeDashboardStore.toggleShortcutsHint(false);
  };
  const handleKeyDown = event => {
    const isAltKey = (event === null || event === void 0 ? void 0 : event.keyCode) === 18 || (event === null || event === void 0 ? void 0 : event.code) === 'AltRight' || (event === null || event === void 0 ? void 0 : event.code) === 'AltLeft';
    if (!isAltKey) {
      clearTimeout(handleShortcutsHintTimerId);
      store.homeDashboardStore.toggleShortcutsHint(false);
    }
    if (event !== null && event !== void 0 && event.altKey && isAltKey) {
      handleShortcutsHintTimerId = setTimeout(() => {
        store.homeDashboardStore.toggleShortcutsHint(true);
      }, 200);
    }
    if (event !== null && event !== void 0 && event.altKey) {
      if ((event === null || event === void 0 ? void 0 : event.keyCode) === '86' || event.code === 'KeyV') {
        // NOTE: Alt + V || Option + V
        if (store.homeDashboardStore.getCurrentCompany.companyDashboardViewType === 'list-view') {
          store.homeDashboardStore.getCurrentCompany.changeCompanyDashboardViewType('navigation-view');
        } else {
          store.homeDashboardStore.getCurrentCompany.changeCompanyDashboardViewType('list-view');
        }
      }
      if ((event === null || event === void 0 ? void 0 : event.keyCode) === '219' || event.code === 'BracketLeft') {
        // NOTE: Alt + [ || Option + [
        // Expand / collapse company admin nav
        store.homeDashboardStore.changeCompaniesNavOpenState();
      }
    } else {
      if ((event === null || event === void 0 ? void 0 : event.keyCode) === '219' || event.code === 'BracketLeft') {
        // NOTE: [
        // Expand / collapse properties nav
        store.homeDashboardStore.getCurrentCompany.changeCompanyPropertiesNavOpenState();
      }
    }
  };
  useEffect(() => {
    const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
    if ((store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && location.pathname.startsWith('/active_dashboard/') && navCompanyId && accessTokenAsync['custom:companyid'] !== navCompanyId) {
      window.location.href = "/companyredirect/".concat(navCompanyId, "?redirectedFrom=").concat(encodeURIComponent(location.pathname));
      return;
    }
    if (location.pathname === '/active_dashboard' || location.pathname === '/active_dashboard/') {
      navigate("/active_dashboard/".concat(accessTokenAsync['custom:companyid'], "/all/all"), {
        replace: true
      });
    } else if (navCompanyId && !navPortfolioId && !navPropertyId) {
      navigate("/active_dashboard/".concat(accessTokenAsync['custom:companyid'], "/all/all"), {
        replace: true
      });
    } else if (navCompanyId && navPortfolioId && !navPropertyId) {
      navigate("/active_dashboard/".concat(accessTokenAsync['custom:companyid'], "/").concat(navPortfolioId, "/all"), {
        replace: true
      });
    }
  }, [location.pathname, navCompanyId, navPortfolioId, navPropertyId, navigate, store.account.userProfile.isUserAdmin, store.account.userProfile.isUserSuperAdmin]);
  useEffect(() => {
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('blur', handleWindowBlur);
    return () => {
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('blur', handleWindowBlur);
      clearTimeout(handleShortcutsHintTimerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Note: Keyboard shortcuts END --------

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NewBillingModuleContent, {
    handleOpenUnitModal: handleOpenUnitModal,
    handleOpenPropertyInfoModal: handleOpenPropertyInfoModal,
    handleOpenUtilityModal: handleOpenBillingTemplateModal,
    handleOpenAmenityModal: handleOpenAmenityModal,
    handleOpenFeeSetupModal: handleOpenFeeSetupModal,
    handleOpenPaymentMethodModal: handleOpenPaymentMethodModal,
    handleOpenReimbursementModal: handleOpenReimbursementModal,
    handleShowEnrollModal: handleShowEnrollModal,
    handleShowManageAccessModal: handleShowManageAccessModal,
    setIsDeletePortfolioModalOpen: setIsDeletePortfolioModalOpen,
    handleShowCreateEditPortfolioTrigger: handleShowCreateEditPortfolioTrigger,
    setDeleteModalProps: setDeleteModalProps,
    triggerRefreshPortfolioData: fetchPortfoliosDataGeneralUpdateTrigger,
    handleOpenCreateAccountModal: () => setIsCreateAccountModal(true),
    handleOpenContactInformationModal: () => {
      store.homeDashboardStore.getCurrentCompany.fetchCompanyTeamMembers({
        // customInProgressFetchId: store.homeDashboardStore.getCurrentProperty.id,
      });
      setIsContactInformationModalOpen(true);
    },
    fetchPropertyInformation: fetchPropertyInformation
  }), /*#__PURE__*/React.createElement(UnitModal, {
    isOpen: isUnitModalOpen,
    handleClose: handleCloseUnitModal
  }), /*#__PURE__*/React.createElement(PropertyDetailsModal, {
    isOpen: isPropertyInfoModalOpen,
    handleClose: handleClosePropertyInfoModal,
    triggerRefresh: () => {
      fetchPropertyInformation();
    }
  }), store.account.featureFlagsStore.getIsBillingTemplatesEnabled && isBillingTemplateModalOpen ? /*#__PURE__*/React.createElement(BillingTemplateModal, {
    key: (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.selectedPropertyDetails()) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.details) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.getBillingTemplateModalForm) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.propertyUtilityId,
    isOpen: isBillingTemplateModalOpen,
    handleClose: handleCloseBillingTemplateModal,
    propertyUtility: ((_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.selectedPropertyDetails()) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.details) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.getBillingTemplateModalForm) || null
  }) : isBillingTemplateModalOpen && /*#__PURE__*/React.createElement(OldUtilityConfigurationModal, {
    key: (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.selectedPropertyDetails()) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.details) === null || _store$homeDashboardS8 === void 0 || (_store$homeDashboardS8 = _store$homeDashboardS8.getUtilityTemplateModalForm) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.id,
    isOpen: isBillingTemplateModalOpen,
    handleClose: handleCloseBillingTemplateModal,
    utility: ((_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.selectedPropertyDetails()) === null || _store$homeDashboardS9 === void 0 || (_store$homeDashboardS9 = _store$homeDashboardS9.details) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.getUtilityTemplateModalForm) || null
  }), /*#__PURE__*/React.createElement(AmenityModal, {
    amenityForm: (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.selectedPropertyDetails()) === null || _store$homeDashboardS0 === void 0 || (_store$homeDashboardS0 = _store$homeDashboardS0.details) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.getAmenityModalForm,
    isOpenExternal: isAmenityModalOpen,
    handleModalCloseExt: () => handleCloseAmenityModal()
  }), /*#__PURE__*/React.createElement(FeeSetupModal, {
    isOpen: isFeeSetupModalOpen,
    handleClose: handleCloseFeeSetupModal
  }), store.account.userProfile.isUserHasAccessToThePayment && isPaymentMethodModalOpen && /*#__PURE__*/React.createElement(PayGateModal, {
    trigger: null,
    methodAdded: newPaymentMethodAdded,
    open: isPaymentMethodModalOpen,
    handleCloseCustom: handleClosePaymentMethodModal
  }), /*#__PURE__*/React.createElement(ReimbursementModal, {
    isOpen: isReimbursementModalOpen,
    handleClose: handleCloseReimbursementModal,
    triggerRefresh: propertyId => {
      // store.homeDashboardStore.getCurrentCompany.fetchCompanyACHs({ customInProgressFetchId: propertyId });
      // store.homeDashboardStore.getCurrentCompany.fetchCompanyRegularChecks({ customInProgressFetchId: propertyId });
      store.homeDashboardStore.getCurrentCompany.fetchCompanyPayoutMethods({
        customInProgressFetchId: propertyId
      });
    }
  }), /*#__PURE__*/React.createElement(EnrollmentModal, {
    key: 'general-billing-module-enroll-modal',
    showCurrentEnrollModal: showEnrollModal,
    handleShowCurrentEnrollModal: handleShowEnrollModal,
    portfolioId: (_enrollModalExtProps$ = enrollModalExtProps === null || enrollModalExtProps === void 0 ? void 0 : enrollModalExtProps.portfolioId) !== null && _enrollModalExtProps$ !== void 0 ? _enrollModalExtProps$ : (_store$homeDashboardS1 = store.homeDashboardStore.getPortfolioByPropertyId((_store$homeDashboardS10 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.id)) === null || _store$homeDashboardS1 === void 0 ? void 0 : _store$homeDashboardS1.id,
    propertyId: (_enrollModalExtProps$2 = enrollModalExtProps === null || enrollModalExtProps === void 0 ? void 0 : enrollModalExtProps.propertyId) !== null && _enrollModalExtProps$2 !== void 0 ? _enrollModalExtProps$2 : (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS11 === void 0 ? void 0 : _store$homeDashboardS11.id,
    enablePortfolioSelect: store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && (store.homeDashboardStore.selectedPortfolioId === 'all' || (enrollModalExtProps === null || enrollModalExtProps === void 0 ? void 0 : enrollModalExtProps.enablePortfolioSelect)),
    enablePropertySelect: store.homeDashboardStore.selectedPropertyId === 'all' || (enrollModalExtProps === null || enrollModalExtProps === void 0 ? void 0 : enrollModalExtProps.enablePropertySelect),
    trigger: null,
    triggerRefresh: propertyId => {
      fetchPortfoliosDataGeneralUpdateTrigger([propertyId]);
    },
    parentToggleRefreshCallback: () => {
      var _store$homeDashboardS12, _store$homeDashboardS13;
      return (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS12 === void 0 || (_store$homeDashboardS12 = _store$homeDashboardS12.companyResidentsTabOptions) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.updateModel({
        refreshResidentsFlag: !((_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS13 !== void 0 && (_store$homeDashboardS13 = _store$homeDashboardS13.companyResidentsTabOptions) !== null && _store$homeDashboardS13 !== void 0 && _store$homeDashboardS13.refreshResidentsFlag)
      });
    },
    newBillingActivated: true
  }), /*#__PURE__*/React.createElement(ManageAccessModal, {
    isEditMode: false,
    customTrigger: null,
    showModal: showManageAccessModal,
    handleShowModal: handleShowManageAccessModal,
    triggerRefresh: () => {
      fetchPortfoliosDataGeneralUpdateTrigger();
    },
    propertyData: propsPropertyDataManageAccessModal,
    portfolioData: propsPortfolioDataManageAccessModal
  }), /*#__PURE__*/React.createElement(CreateEditPortfolioModal, {
    customTrigger: null,
    isEditMode: true,
    existingPortfolio: renameModalProps || store.homeDashboardStore.getCurrentPortfolio,
    triggerRefresh: () => {
      fetchPortfoliosDataGeneralUpdateTrigger();
    },
    showModal: isRenamePortfolioModalOpen,
    handleShowModal: handleShowCreateEditPortfolioTrigger
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    externalIsOpen: isDeletePortfolioModalOpen,
    headerText: t('portfolios_properties_page.delete_portfolio'),
    bodyText: t('portfolios_properties_page.you_are_about_to_delete_portfolio', {
      portfolioName: deleteModalProps === null || deleteModalProps === void 0 || (_deleteModalProps$sel2 = deleteModalProps.selectedPortfolio) === null || _deleteModalProps$sel2 === void 0 ? void 0 : _deleteModalProps$sel2.name
    }),
    callBack: _ref2 => {
      let action = _ref2.action,
        objectToPassOver = _ref2.objectToPassOver;
      if (action === 'submit') {
        deletePortfolioHandler(objectToPassOver);
      }
      setIsDeletePortfolioModalOpen(false);
    }
  }), /*#__PURE__*/React.createElement(CreateAccountModal, {
    isOpen: isCreateAccountModal,
    handleClose: () => setIsCreateAccountModal(false),
    trigger: null
  }), /*#__PURE__*/React.createElement(ContactInformationModal, {
    isOpen: isContactInformationModalOpen,
    handleClose: () => setIsContactInformationModalOpen(false)
  }));
});